module.exports = __webpack_public_path__ + "static/img/javascript.c4ca8fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/javascript.png
// module id = /sov
// module chunks = 0